module.exports = __webpack_public_path__ + "static/media/8.4a18aa82.jpg";